module.exports = __webpack_public_path__ + "static/media/home_for_rent 2.95d2f247.svg";